module.exports = __webpack_public_path__ + "img/lvape_lasvegaskind.6309e97.png";